import { render, staticRenderFns } from "./RightMenuSidebar.vue?vue&type=template&id=0657c1c4"
import script from "./RightMenuSidebar.vue?vue&type=script&lang=js"
export * from "./RightMenuSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports